export default () => ({
  type: 'line',
  data: {},
  options: {
    layout: {
      padding: {
        left: 20,
        right: 0,
        top: 0,
        bottom: 5,
      },
    },
    legend: {
      // position: 'right',
    },
    animation: {
      duration: 1000,
      easing: 'easeInOutQuart', // easeInQuad, easeOutQuad, easeInOutQuad, easeInCubic, easeOutCubic, easeInQuint
    },
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      position: 'average',  // average, nearest
      mode: 'index',        // nearest, index
      intersect: false,
    },
    title: {
      display: true,
      fontSize: 22,
      fontFamily: 'Roboto',
      fontColor: '#333',
      fontStyle: 'bold',
    },
    scales: {
      xAxes: [{
        type: 'time',
        time: {
          unit: 'hour',      // millisecond, second, minute, hour, day, week, month, quarter, year
          displayFormats: {
            hour: 'MMM D h:mm a',
          },
          tooltipFormat: 'MMM D h:mm a',
          // stepSize: 1,
        },
        distribution: 'linear',    // linear, series
        ticks: {
          source: 'labels',     // auto, data, labels
          // minRotation: 0,
          // maxRotation: 10,
          padding: 5,
        },
        scaleLabel: {
          display: true,
          labelString: 'Date',
          fontSize: 16,
        },
      }],
      yAxes: [{
        // type: 'logarithmic',
        ticks: {},
        scaleLabel: {
          display: true,
          fontSize: 16,
        },
      }],
    },
  },
});



// WEBPACK FOOTER //
// ./src/config/sensorVariableChartDefaults.js